module.exports = __webpack_public_path__ + "static/media/cooper.a91a449f.jpg";